import React, { useEffect, useState } from "react";
import MonacoEditor, { loader } from "@monaco-editor/react";
import iPlastic from "monaco-themes/themes/iPlastic.json";
import { useThemeContext } from "../theme/ThemeContext";

const CodeEditor = ({
  language = "json",
  value = "",
  onChange = () => {}, // Handles editing
  height = "30rem",
  width = "55rem",
  showMinimap = false,
  readOnly = false, // Toggle editor/viewer mode (accepts string or boolean)
  // selectedTheme is intentionally ignored — theme is derived from app mode (inverted)
  // dark app → white/light editor so the secret content is easy to read
  // light app → dark editor for contrast
}) => {
  const [themeLoaded, setThemeLoaded] = useState(false);
  const isMinimapEnabled = showMinimap === true || showMinimap === "true";
  const { mode } = useThemeContext();

  // Convert string "true"/"false" to boolean
  const isReadOnly = readOnly === true || readOnly === "true";

  useEffect(() => {
    loader.init().then((monaco) => {
      // Define iPlastic theme every time (safe way to ensure it exists)
      monaco.editor.defineTheme("iplastic", iPlastic);
      setThemeLoaded(true);
    });
  }, []);

  return (
    <div className="border border-color-border-secondary" style={{ height, width }}>
      {themeLoaded && (
        <MonacoEditor
          height="40rem"
          width="100%"
          language={language}
          theme={mode === 'dark' ? 'vs' : 'vs-dark'}  // inverted: dark app = white editor, light app = dark editor
          value={value}
          onChange={onChange}
          options={{
            readOnly: isReadOnly,
            minimap: { enabled: isMinimapEnabled },
            scrollBeyondLastLine: false,
            wordWrap: "off",
          }}
        />
      )}
    </div>
  );
};

export default CodeEditor;